import PromotionsApi from './PromotionsApi';

export default PromotionsApi;
